export default "__VITE_ASSET__C2Qf_8FL__"